import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";

const MOTIVI_RAPIDI = ["Rifiuta di alzarsi", "Stanco", "Indicazione dell'infermiere", "Indicazione del medico", "Dolore", "Malessere"];

export function NonAlzatoDialog({ ctx, onClose, onSaved }) {
  const [motivo, setMotivo] = useState("");
  const [perEvento, setPerEvento] = useState(false);
  const [saving, setSaving] = useState(false);
  useEffect(() => { setMotivo(""); setPerEvento(false); }, [ctx]);
  if (!ctx) return null;
  const evTxt = ctx.evento ? `Non alzato per evento sanitario aperto: ${ctx.evento}` : "";
  const save = async () => {
    const m = perEvento ? evTxt + (motivo.trim() ? ` — ${motivo.trim()}` : "") : motivo.trim();
    if (!m) { toast.error("Scrivi il motivo per cui non è stato alzato"); return; }
    setSaving(true);
    try {
      await api.post("/alzate/non-alzato", { ...ctx.payload, motivo: m, per_evento: perEvento, evento: perEvento ? ctx.evento : "" });
      toast.success("Registrato come non alzato");
      onSaved(); onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
    setSaving(false);
  };
  return (
    <Dialog open onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="non-alzato-dialog">
        <DialogHeader><DialogTitle>Non alzato · {ctx.nome}</DialogTitle></DialogHeader>
        <div>
          <label className="text-xs font-semibold text-muted-foreground block mb-1">{perEvento ? "Note aggiuntive (facoltative)" : "Perché non è stato alzato?"}</label>
          <div className="flex flex-wrap gap-1.5 mb-2" data-testid="non-alzato-motivi-rapidi">
            {ctx.evento && (
              <button type="button" onClick={() => setPerEvento((v) => !v)} aria-pressed={perEvento}
                className={`basis-full text-left text-sm font-bold rounded-lg px-3 py-2.5 border-2 transition-colors ${perEvento ? "bg-red-600 text-white border-red-600" : "bg-white text-red-700 border-red-500 hover:bg-red-50"}`}
                data-testid="non-alzato-evento-check">{perEvento ? "✓ " : ""}Evento sanitario aperto: {ctx.evento}</button>
            )}
            {MOTIVI_RAPIDI.map((m) => (
              <button key={m} type="button" onClick={() => setMotivo(m)}
                className={`text-xs font-semibold rounded-full px-3 py-1.5 border transition-colors ${motivo === m ? "bg-red-600 text-white border-red-600" : "bg-white text-slate-700 border-slate-300 hover:bg-red-50"}`}
                data-testid={`non-alzato-motivo-rapido-${m.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{m}</button>
            ))}
          </div>
          <Textarea value={motivo} onChange={(e) => setMotivo(e.target.value)} rows={3} placeholder="Es. ospite stanco, rifiuta di alzarsi, indicazione dell'infermiere…" data-testid="non-alzato-motivo" />
        </div>
        <p className="text-xs text-muted-foreground">L'ospite resterà a letto: nella Messa a letto di oggi risulterà già a letto.</p>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="non-alzato-annulla">Annulla</Button>
          <Button onClick={save} disabled={saving} className="bg-red-600 hover:bg-red-700" data-testid="non-alzato-salva">Conferma non alzato</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
